import { Injectable } from '@angular/core';
import {
  HttpEvent, HttpInterceptor, HttpHandler, HttpRequest
} from '@angular/common/http';

import {Observable} from 'rxjs';
import {ViewService} from "../services/view/view.service";
import {finalize} from "rxjs/operators";

@Injectable()
export class NoopInterceptor implements HttpInterceptor {
  constructor(private viewService: ViewService) {}
  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(req).pipe(finalize(() => setTimeout(() => this.viewService.triggerCdr(), 0)));
  }
}


